import { useQuery } from '@apollo/client';
import React from 'react';

import { ContactBackgroundCheck } from 'features/brazil-grower/components/BrazilGrowerFinance/components/BackgroundCheck/ContactBackgroundCheck';
import { latestBackgroundCheck } from 'features/brazil-grower/queries/backgroundCheck.queries';

interface Props {
  taxIdentifier: string;
  title: string;
}

export const BackgroundCheckCard = ({ taxIdentifier, title }: Props) => {
  const backgroundCheckQuery = useQuery(latestBackgroundCheck, { variables: { taxIdentifier } });
  const { data, loading } = backgroundCheckQuery;

  return (
    <ContactBackgroundCheck backgroundCheck={data?.latestBackgroundCheck} loading={loading} readOnly title={title} />
  );
};
